// ⚠️ AUTO-GENERATED by scripts/generate-image-manifest.mjs — 직접 수정 금지
// 재생성: npm run gen:images  (public/assets의 스마트폰 이미지 폴더 스캔 결과)
// path는 실제 파일명 기준 URL 인코딩 완료 상태 (Firebase Hosting 대소문자/공백/한글 대응)

export interface PhoneImageEntry {
  file: string;
  path: string;
  brand: 'samsung' | 'apple';
  line: 's' | 'flip' | 'fold' | 'note' | 'a' | 'j' | 'm' | 'etc' | 'iphone'
    | 'tabs' | 'taba' | 'pad' | 'pro' | 'air' | 'mini';
  gen: string;
  genOrder: number;
  variant: string;
  size?: string; // 태블릿 화면 크기 ('105' = 10.5인치)
  nameKey?: string; // 특수 모델(버디·점프·와이드 등) 정규화 키
  pathOnly?: boolean; // 구조 파싱 불가 — 경로 실존 검증(카탈로그 image 채택)용
}

export const PHONE_IMAGE_ENTRIES: PhoneImageEntry[] = [
  {
    "file": "에어3세대.png",
    "path": "/assets/ipadAir/%EC%97%90%EC%96%B43%EC%84%B8%EB%8C%80.png",
    "brand": "apple",
    "line": "air",
    "gen": "3",
    "genOrder": 3,
    "variant": ""
  },
  {
    "file": "에어4세대.png",
    "path": "/assets/ipadAir/%EC%97%90%EC%96%B44%EC%84%B8%EB%8C%80.png",
    "brand": "apple",
    "line": "air",
    "gen": "4",
    "genOrder": 4,
    "variant": ""
  },
  {
    "file": "에어5세대.png",
    "path": "/assets/ipadAir/%EC%97%90%EC%96%B45%EC%84%B8%EB%8C%80.png",
    "brand": "apple",
    "line": "air",
    "gen": "5",
    "genOrder": 5,
    "variant": ""
  },
  {
    "file": "에어6세대.png",
    "path": "/assets/ipadAir/%EC%97%90%EC%96%B46%EC%84%B8%EB%8C%80.png",
    "brand": "apple",
    "line": "air",
    "gen": "6",
    "genOrder": 6,
    "variant": ""
  },
  {
    "file": "6.png",
    "path": "/assets/iPhone/iPhone6/6.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "6",
    "genOrder": 6,
    "variant": ""
  },
  {
    "file": "iphone6plus.jpg",
    "path": "/assets/iPhone/iPhone6/iphone6plus.jpg",
    "brand": "apple",
    "line": "iphone",
    "gen": "6",
    "genOrder": 6,
    "variant": "plus"
  },
  {
    "file": "6S.png",
    "path": "/assets/iPhone/iPhone6/6S.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "6s",
    "genOrder": 6.5,
    "variant": ""
  },
  {
    "file": "6S+.png",
    "path": "/assets/iPhone/iPhone6/6S+.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "6s",
    "genOrder": 6.5,
    "variant": "plus"
  },
  {
    "file": "SE1.png",
    "path": "/assets/iPhone/iPhoneSE/SE1.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "se",
    "genOrder": 6.7,
    "variant": ""
  },
  {
    "file": "7.png",
    "path": "/assets/iPhone/iPhone7/7.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "7",
    "genOrder": 7,
    "variant": ""
  },
  {
    "file": "7+.png",
    "path": "/assets/iPhone/iPhone7/7+.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "7",
    "genOrder": 7,
    "variant": "plus"
  },
  {
    "file": "8.png",
    "path": "/assets/iPhone/iPhone8/8.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "8",
    "genOrder": 8,
    "variant": ""
  },
  {
    "file": "8+.png",
    "path": "/assets/iPhone/iPhone8/8+.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "8",
    "genOrder": 8,
    "variant": "plus"
  },
  {
    "file": "X.png",
    "path": "/assets/iPhone/iPhoneX/X.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "x",
    "genOrder": 10,
    "variant": ""
  },
  {
    "file": "XS.png",
    "path": "/assets/iPhone/iPhoneX/XS.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "xs",
    "genOrder": 10.1,
    "variant": ""
  },
  {
    "file": "XS MAX.png",
    "path": "/assets/iPhone/iPhoneX/XS%20MAX.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "xs",
    "genOrder": 10.1,
    "variant": "max"
  },
  {
    "file": "XR.png",
    "path": "/assets/iPhone/iPhoneX/XR.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "xr",
    "genOrder": 10.2,
    "variant": ""
  },
  {
    "file": "11.png",
    "path": "/assets/iPhone/iPhone11/11.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "11",
    "genOrder": 11,
    "variant": ""
  },
  {
    "file": "11pro.png",
    "path": "/assets/iPhone/iPhone11/11pro.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "11",
    "genOrder": 11,
    "variant": "pro"
  },
  {
    "file": "11pro max.png",
    "path": "/assets/iPhone/iPhone11/11pro%20max.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "11",
    "genOrder": 11,
    "variant": "promax"
  },
  {
    "file": "SE2.png",
    "path": "/assets/iPhone/iPhoneSE/SE2.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "se2",
    "genOrder": 11.5,
    "variant": ""
  },
  {
    "file": "12.png",
    "path": "/assets/iPhone/iPhone12/12.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "12",
    "genOrder": 12,
    "variant": ""
  },
  {
    "file": "12 mini.png",
    "path": "/assets/iPhone/iPhone12/12%20mini.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "12",
    "genOrder": 12,
    "variant": "mini"
  },
  {
    "file": "12pro.png",
    "path": "/assets/iPhone/iPhone12/12pro.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "12",
    "genOrder": 12,
    "variant": "pro"
  },
  {
    "file": "12pro max.png",
    "path": "/assets/iPhone/iPhone12/12pro%20max.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "12",
    "genOrder": 12,
    "variant": "promax"
  },
  {
    "file": "13.png",
    "path": "/assets/iPhone/iPhone13/13.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "13",
    "genOrder": 13,
    "variant": ""
  },
  {
    "file": "13 mini.png",
    "path": "/assets/iPhone/iPhone13/13%20mini.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "13",
    "genOrder": 13,
    "variant": "mini"
  },
  {
    "file": "13pro.png",
    "path": "/assets/iPhone/iPhone13/13pro.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "13",
    "genOrder": 13,
    "variant": "pro"
  },
  {
    "file": "13pro max.png",
    "path": "/assets/iPhone/iPhone13/13pro%20max.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "13",
    "genOrder": 13,
    "variant": "promax"
  },
  {
    "file": "SE3.png",
    "path": "/assets/iPhone/iPhoneSE/SE3.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "se3",
    "genOrder": 13.5,
    "variant": ""
  },
  {
    "file": "14.png",
    "path": "/assets/iPhone/iPhone14/14.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "14",
    "genOrder": 14,
    "variant": ""
  },
  {
    "file": "14+.png",
    "path": "/assets/iPhone/iPhone14/14+.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "14",
    "genOrder": 14,
    "variant": "plus"
  },
  {
    "file": "14pro.png",
    "path": "/assets/iPhone/iPhone14/14pro.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "14",
    "genOrder": 14,
    "variant": "pro"
  },
  {
    "file": "14pro max.png",
    "path": "/assets/iPhone/iPhone14/14pro%20max.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "14",
    "genOrder": 14,
    "variant": "promax"
  },
  {
    "file": "15.png",
    "path": "/assets/iPhone/iPhone15/15.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "15",
    "genOrder": 15,
    "variant": ""
  },
  {
    "file": "15+.png",
    "path": "/assets/iPhone/iPhone15/15+.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "15",
    "genOrder": 15,
    "variant": "plus"
  },
  {
    "file": "15pro.png",
    "path": "/assets/iPhone/iPhone15/15pro.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "15",
    "genOrder": 15,
    "variant": "pro"
  },
  {
    "file": "15pro max.png",
    "path": "/assets/iPhone/iPhone15/15pro%20max.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "15",
    "genOrder": 15,
    "variant": "promax"
  },
  {
    "file": "16.png",
    "path": "/assets/iPhone/iPhone16/16.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "16",
    "genOrder": 16,
    "variant": ""
  },
  {
    "file": "16e.png",
    "path": "/assets/iPhone/iPhone16/16e.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "16",
    "genOrder": 16,
    "variant": "e"
  },
  {
    "file": "16+.png",
    "path": "/assets/iPhone/iPhone16/16+.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "16",
    "genOrder": 16,
    "variant": "plus"
  },
  {
    "file": "16pro.png",
    "path": "/assets/iPhone/iPhone16/16pro.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "16",
    "genOrder": 16,
    "variant": "pro"
  },
  {
    "file": "16pro max.png",
    "path": "/assets/iPhone/iPhone16/16pro%20max.png",
    "brand": "apple",
    "line": "iphone",
    "gen": "16",
    "genOrder": 16,
    "variant": "promax"
  },
  {
    "file": "미니5세대.png",
    "path": "/assets/ipadMini/%EB%AF%B8%EB%8B%885%EC%84%B8%EB%8C%80.png",
    "brand": "apple",
    "line": "mini",
    "gen": "5",
    "genOrder": 5,
    "variant": ""
  },
  {
    "file": "미니6세대.png",
    "path": "/assets/ipadMini/%EB%AF%B8%EB%8B%886%EC%84%B8%EB%8C%80.png",
    "brand": "apple",
    "line": "mini",
    "gen": "6",
    "genOrder": 6,
    "variant": ""
  },
  {
    "file": "미니7세대.png",
    "path": "/assets/ipadMini/%EB%AF%B8%EB%8B%887%EC%84%B8%EB%8C%80.png",
    "brand": "apple",
    "line": "mini",
    "gen": "7",
    "genOrder": 7,
    "variant": ""
  },
  {
    "file": "패드5세대.png",
    "path": "/assets/ipad/%ED%8C%A8%EB%93%9C5%EC%84%B8%EB%8C%80.png",
    "brand": "apple",
    "line": "pad",
    "gen": "5",
    "genOrder": 5,
    "variant": ""
  },
  {
    "file": "패드6세대.png",
    "path": "/assets/ipad/%ED%8C%A8%EB%93%9C6%EC%84%B8%EB%8C%80.png",
    "brand": "apple",
    "line": "pad",
    "gen": "6",
    "genOrder": 6,
    "variant": ""
  },
  {
    "file": "패드7세대.png",
    "path": "/assets/ipad/%ED%8C%A8%EB%93%9C7%EC%84%B8%EB%8C%80.png",
    "brand": "apple",
    "line": "pad",
    "gen": "7",
    "genOrder": 7,
    "variant": ""
  },
  {
    "file": "패드8세대.png",
    "path": "/assets/ipad/%ED%8C%A8%EB%93%9C8%EC%84%B8%EB%8C%80.png",
    "brand": "apple",
    "line": "pad",
    "gen": "8",
    "genOrder": 8,
    "variant": ""
  },
  {
    "file": "패드9세대.png",
    "path": "/assets/ipad/%ED%8C%A8%EB%93%9C9%EC%84%B8%EB%8C%80.png",
    "brand": "apple",
    "line": "pad",
    "gen": "9",
    "genOrder": 9,
    "variant": ""
  },
  {
    "file": "패드10세대.png",
    "path": "/assets/ipad/%ED%8C%A8%EB%93%9C10%EC%84%B8%EB%8C%80.png",
    "brand": "apple",
    "line": "pad",
    "gen": "10",
    "genOrder": 10,
    "variant": ""
  },
  {
    "file": "프로5_7세대 11_12.9.png",
    "path": "/assets/ipadPro/%ED%94%84%EB%A1%9C5_7%EC%84%B8%EB%8C%80%2011_12.9.png",
    "brand": "apple",
    "line": "pro",
    "gen": "",
    "genOrder": -1,
    "variant": "",
    "pathOnly": true
  },
  {
    "file": "프로1세대 11인치.png",
    "path": "/assets/ipadPro/%ED%94%84%EB%A1%9C1%EC%84%B8%EB%8C%80%2011%EC%9D%B8%EC%B9%98.png",
    "brand": "apple",
    "line": "pro",
    "gen": "1",
    "genOrder": 1,
    "variant": "",
    "size": "11"
  },
  {
    "file": "프로1세대 9.7.png",
    "path": "/assets/ipadPro/%ED%94%84%EB%A1%9C1%EC%84%B8%EB%8C%80%209.7.png",
    "brand": "apple",
    "line": "pro",
    "gen": "1",
    "genOrder": 1,
    "variant": "",
    "size": "97"
  },
  {
    "file": "프로2세대 10.5.png",
    "path": "/assets/ipadPro/%ED%94%84%EB%A1%9C2%EC%84%B8%EB%8C%80%2010.5.png",
    "brand": "apple",
    "line": "pro",
    "gen": "2",
    "genOrder": 2,
    "variant": "",
    "size": "105"
  },
  {
    "file": "프로2세대 11.png",
    "path": "/assets/ipadPro/%ED%94%84%EB%A1%9C2%EC%84%B8%EB%8C%80%2011.png",
    "brand": "apple",
    "line": "pro",
    "gen": "2",
    "genOrder": 2,
    "variant": "",
    "size": "11"
  },
  {
    "file": "프로3세대 11 M1.png",
    "path": "/assets/ipadPro/%ED%94%84%EB%A1%9C3%EC%84%B8%EB%8C%80%2011%20M1.png",
    "brand": "apple",
    "line": "pro",
    "gen": "3",
    "genOrder": 3,
    "variant": "",
    "size": "11"
  },
  {
    "file": "프로3세대 12.9.png",
    "path": "/assets/ipadPro/%ED%94%84%EB%A1%9C3%EC%84%B8%EB%8C%80%2012.9.png",
    "brand": "apple",
    "line": "pro",
    "gen": "3",
    "genOrder": 3,
    "variant": "",
    "size": "129"
  },
  {
    "file": "프로4세대 11.png",
    "path": "/assets/ipadPro/%ED%94%84%EB%A1%9C4%EC%84%B8%EB%8C%80%2011.png",
    "brand": "apple",
    "line": "pro",
    "gen": "4",
    "genOrder": 4,
    "variant": "",
    "size": "11"
  },
  {
    "file": "프로4세대 12.9.png",
    "path": "/assets/ipadPro/%ED%94%84%EB%A1%9C4%EC%84%B8%EB%8C%80%2012.9.png",
    "brand": "apple",
    "line": "pro",
    "gen": "4",
    "genOrder": 4,
    "variant": "",
    "size": "129"
  },
  {
    "file": "프로5세대 11.png",
    "path": "/assets/ipadPro/%ED%94%84%EB%A1%9C5%EC%84%B8%EB%8C%80%2011.png",
    "brand": "apple",
    "line": "pro",
    "gen": "5",
    "genOrder": 5,
    "variant": "",
    "size": "11"
  },
  {
    "file": "프로6세대 12.9.png",
    "path": "/assets/ipadPro/%ED%94%84%EB%A1%9C6%EC%84%B8%EB%8C%80%2012.9.png",
    "brand": "apple",
    "line": "pro",
    "gen": "6",
    "genOrder": 6,
    "variant": "",
    "size": "129"
  },
  {
    "file": "A3.png",
    "path": "/assets/samsung/galaxyA/A3.png",
    "brand": "samsung",
    "line": "a",
    "gen": "3",
    "genOrder": 3,
    "variant": ""
  },
  {
    "file": "A5.png",
    "path": "/assets/samsung/galaxyA/A5.png",
    "brand": "samsung",
    "line": "a",
    "gen": "5",
    "genOrder": 5,
    "variant": ""
  },
  {
    "file": "A6.png",
    "path": "/assets/samsung/galaxyA/A6.png",
    "brand": "samsung",
    "line": "a",
    "gen": "6",
    "genOrder": 6,
    "variant": ""
  },
  {
    "file": "A6+.png",
    "path": "/assets/samsung/galaxyA/A6+.png",
    "brand": "samsung",
    "line": "a",
    "gen": "6",
    "genOrder": 6,
    "variant": "plus"
  },
  {
    "file": "A7.png",
    "path": "/assets/samsung/galaxyA/A7.png",
    "brand": "samsung",
    "line": "a",
    "gen": "7",
    "genOrder": 7,
    "variant": ""
  },
  {
    "file": "A8.png",
    "path": "/assets/samsung/galaxyA/A8.png",
    "brand": "samsung",
    "line": "a",
    "gen": "8",
    "genOrder": 8,
    "variant": ""
  },
  {
    "file": "A8_STAR.png",
    "path": "/assets/samsung/galaxyA/A8_STAR.png",
    "brand": "samsung",
    "line": "a",
    "gen": "8",
    "genOrder": 8,
    "variant": "star"
  },
  {
    "file": "A9.png",
    "path": "/assets/samsung/galaxyA/A9.png",
    "brand": "samsung",
    "line": "a",
    "gen": "9",
    "genOrder": 9,
    "variant": ""
  },
  {
    "file": "A9_PRO.png",
    "path": "/assets/samsung/galaxyA/A9_PRO.png",
    "brand": "samsung",
    "line": "a",
    "gen": "9",
    "genOrder": 9,
    "variant": "pro"
  },
  {
    "file": "A10.png",
    "path": "/assets/samsung/galaxyA/A10.png",
    "brand": "samsung",
    "line": "a",
    "gen": "10",
    "genOrder": 10,
    "variant": ""
  },
  {
    "file": "A10E.png",
    "path": "/assets/samsung/galaxyA/A10E.png",
    "brand": "samsung",
    "line": "a",
    "gen": "10",
    "genOrder": 10,
    "variant": "e"
  },
  {
    "file": "A12.png",
    "path": "/assets/samsung/galaxyA/A12.png",
    "brand": "samsung",
    "line": "a",
    "gen": "12",
    "genOrder": 12,
    "variant": ""
  },
  {
    "file": "A13.webp",
    "path": "/assets/samsung/galaxyA/A13.webp",
    "brand": "samsung",
    "line": "a",
    "gen": "13",
    "genOrder": 13,
    "variant": ""
  },
  {
    "file": "A15.png",
    "path": "/assets/samsung/galaxyA/A15.png",
    "brand": "samsung",
    "line": "a",
    "gen": "15",
    "genOrder": 15,
    "variant": ""
  },
  {
    "file": "A16.png",
    "path": "/assets/samsung/galaxyA/A16.png",
    "brand": "samsung",
    "line": "a",
    "gen": "16",
    "genOrder": 16,
    "variant": ""
  },
  {
    "file": "A20.png",
    "path": "/assets/samsung/galaxyA/A20.png",
    "brand": "samsung",
    "line": "a",
    "gen": "20",
    "genOrder": 20,
    "variant": ""
  },
  {
    "file": "A21S.png",
    "path": "/assets/samsung/galaxyA/A21S.png",
    "brand": "samsung",
    "line": "a",
    "gen": "21",
    "genOrder": 21,
    "variant": "s"
  },
  {
    "file": "A23.png",
    "path": "/assets/samsung/galaxyA/A23.png",
    "brand": "samsung",
    "line": "a",
    "gen": "23",
    "genOrder": 23,
    "variant": ""
  },
  {
    "file": "A24.webp",
    "path": "/assets/samsung/galaxyA/A24.webp",
    "brand": "samsung",
    "line": "a",
    "gen": "24",
    "genOrder": 24,
    "variant": ""
  },
  {
    "file": "A25.png",
    "path": "/assets/samsung/galaxyA/A25.png",
    "brand": "samsung",
    "line": "a",
    "gen": "25",
    "genOrder": 25,
    "variant": ""
  },
  {
    "file": "A30.png",
    "path": "/assets/samsung/galaxyA/A30.png",
    "brand": "samsung",
    "line": "a",
    "gen": "30",
    "genOrder": 30,
    "variant": ""
  },
  {
    "file": "A31.png",
    "path": "/assets/samsung/galaxyA/A31.png",
    "brand": "samsung",
    "line": "a",
    "gen": "31",
    "genOrder": 31,
    "variant": ""
  },
  {
    "file": "A32.png",
    "path": "/assets/samsung/galaxyA/A32.png",
    "brand": "samsung",
    "line": "a",
    "gen": "32",
    "genOrder": 32,
    "variant": ""
  },
  {
    "file": "A33.png",
    "path": "/assets/samsung/galaxyA/A33.png",
    "brand": "samsung",
    "line": "a",
    "gen": "33",
    "genOrder": 33,
    "variant": ""
  },
  {
    "file": "A34.png",
    "path": "/assets/samsung/galaxyA/A34.png",
    "brand": "samsung",
    "line": "a",
    "gen": "34",
    "genOrder": 34,
    "variant": ""
  },
  {
    "file": "A35.png",
    "path": "/assets/samsung/galaxyA/A35.png",
    "brand": "samsung",
    "line": "a",
    "gen": "35",
    "genOrder": 35,
    "variant": ""
  },
  {
    "file": "A36.png",
    "path": "/assets/samsung/galaxyA/A36.png",
    "brand": "samsung",
    "line": "a",
    "gen": "36",
    "genOrder": 36,
    "variant": ""
  },
  {
    "file": "A40.png",
    "path": "/assets/samsung/galaxyA/A40.png",
    "brand": "samsung",
    "line": "a",
    "gen": "40",
    "genOrder": 40,
    "variant": ""
  },
  {
    "file": "A42.png",
    "path": "/assets/samsung/galaxyA/A42.png",
    "brand": "samsung",
    "line": "a",
    "gen": "42",
    "genOrder": 42,
    "variant": ""
  },
  {
    "file": "A50.png",
    "path": "/assets/samsung/galaxyA/A50.png",
    "brand": "samsung",
    "line": "a",
    "gen": "50",
    "genOrder": 50,
    "variant": ""
  },
  {
    "file": "A51.png",
    "path": "/assets/samsung/galaxyA/A51.png",
    "brand": "samsung",
    "line": "a",
    "gen": "51",
    "genOrder": 51,
    "variant": ""
  },
  {
    "file": "A52.png",
    "path": "/assets/samsung/galaxyA/A52.png",
    "brand": "samsung",
    "line": "a",
    "gen": "52",
    "genOrder": 52,
    "variant": ""
  },
  {
    "file": "A52S.png",
    "path": "/assets/samsung/galaxyA/A52S.png",
    "brand": "samsung",
    "line": "a",
    "gen": "52",
    "genOrder": 52,
    "variant": "s"
  },
  {
    "file": "A53.png",
    "path": "/assets/samsung/galaxyA/A53.png",
    "brand": "samsung",
    "line": "a",
    "gen": "53",
    "genOrder": 53,
    "variant": ""
  },
  {
    "file": "A70.png",
    "path": "/assets/samsung/galaxyA/A70.png",
    "brand": "samsung",
    "line": "a",
    "gen": "70",
    "genOrder": 70,
    "variant": ""
  },
  {
    "file": "A71.png",
    "path": "/assets/samsung/galaxyA/A71.png",
    "brand": "samsung",
    "line": "a",
    "gen": "71",
    "genOrder": 71,
    "variant": ""
  },
  {
    "file": "A80.png",
    "path": "/assets/samsung/galaxyA/A80.png",
    "brand": "samsung",
    "line": "a",
    "gen": "80",
    "genOrder": 80,
    "variant": ""
  },
  {
    "file": "A82.png",
    "path": "/assets/samsung/galaxyA/A82.png",
    "brand": "samsung",
    "line": "a",
    "gen": "82",
    "genOrder": 82,
    "variant": ""
  },
  {
    "file": "A90.png",
    "path": "/assets/samsung/galaxyA/A90.png",
    "brand": "samsung",
    "line": "a",
    "gen": "90",
    "genOrder": 90,
    "variant": ""
  },
  {
    "file": "BUDDY.webp",
    "path": "/assets/samsung/galaxyA/BUDDY.webp",
    "brand": "samsung",
    "line": "etc",
    "gen": "",
    "genOrder": -1,
    "variant": "",
    "nameKey": "buddy"
  },
  {
    "file": "BUDDY2.png",
    "path": "/assets/samsung/galaxyA/BUDDY2.png",
    "brand": "samsung",
    "line": "etc",
    "gen": "",
    "genOrder": -1,
    "variant": "",
    "nameKey": "buddy2"
  },
  {
    "file": "BUDDY3.png",
    "path": "/assets/samsung/galaxyA/BUDDY3.png",
    "brand": "samsung",
    "line": "etc",
    "gen": "",
    "genOrder": -1,
    "variant": "",
    "nameKey": "buddy3"
  },
  {
    "file": "BUDDY4.png",
    "path": "/assets/samsung/galaxyA/BUDDY4.png",
    "brand": "samsung",
    "line": "etc",
    "gen": "",
    "genOrder": -1,
    "variant": "",
    "nameKey": "buddy4"
  },
  {
    "file": "FOLDER1.png",
    "path": "/assets/samsung/galaxyA/FOLDER1.png",
    "brand": "samsung",
    "line": "etc",
    "gen": "",
    "genOrder": -1,
    "variant": "",
    "nameKey": "folder1"
  },
  {
    "file": "FOLDER2.png",
    "path": "/assets/samsung/galaxyA/FOLDER2.png",
    "brand": "samsung",
    "line": "etc",
    "gen": "",
    "genOrder": -1,
    "variant": "",
    "nameKey": "folder2"
  },
  {
    "file": "GOLDEN.png",
    "path": "/assets/samsung/galaxyA/GOLDEN.png",
    "brand": "samsung",
    "line": "etc",
    "gen": "",
    "genOrder": -1,
    "variant": "",
    "nameKey": "golden"
  },
  {
    "file": "JUMP.png",
    "path": "/assets/samsung/galaxyA/JUMP.png",
    "brand": "samsung",
    "line": "etc",
    "gen": "",
    "genOrder": -1,
    "variant": "",
    "nameKey": "jump"
  },
  {
    "file": "JUMP2.png",
    "path": "/assets/samsung/galaxyA/JUMP2.png",
    "brand": "samsung",
    "line": "etc",
    "gen": "",
    "genOrder": -1,
    "variant": "",
    "nameKey": "jump2"
  },
  {
    "file": "JUMP3.png",
    "path": "/assets/samsung/galaxyA/JUMP3.png",
    "brand": "samsung",
    "line": "etc",
    "gen": "",
    "genOrder": -1,
    "variant": "",
    "nameKey": "jump3"
  },
  {
    "file": "JUMP4.webp",
    "path": "/assets/samsung/galaxyA/JUMP4.webp",
    "brand": "samsung",
    "line": "etc",
    "gen": "",
    "genOrder": -1,
    "variant": "",
    "nameKey": "jump4"
  },
  {
    "file": "MIVE_KIDSPHONE.png",
    "path": "/assets/samsung/galaxyA/MIVE_KIDSPHONE.png",
    "brand": "samsung",
    "line": "etc",
    "gen": "",
    "genOrder": -1,
    "variant": "",
    "nameKey": "kidsphone"
  },
  {
    "file": "ON7.png",
    "path": "/assets/samsung/galaxyA/ON7.png",
    "brand": "samsung",
    "line": "etc",
    "gen": "",
    "genOrder": -1,
    "variant": "",
    "nameKey": "on7"
  },
  {
    "file": "QUANTUM3.png",
    "path": "/assets/samsung/galaxyA/QUANTUM3.png",
    "brand": "samsung",
    "line": "etc",
    "gen": "",
    "genOrder": -1,
    "variant": "",
    "nameKey": "quantum3"
  },
  {
    "file": "QUANTUM4.png",
    "path": "/assets/samsung/galaxyA/QUANTUM4.png",
    "brand": "samsung",
    "line": "etc",
    "gen": "",
    "genOrder": -1,
    "variant": "",
    "nameKey": "quantum4"
  },
  {
    "file": "QUANTUM5.png",
    "path": "/assets/samsung/galaxyA/QUANTUM5.png",
    "brand": "samsung",
    "line": "etc",
    "gen": "",
    "genOrder": -1,
    "variant": "",
    "nameKey": "quantum5"
  },
  {
    "file": "STYLE_FOLDER.png",
    "path": "/assets/samsung/galaxyA/STYLE_FOLDER.png",
    "brand": "samsung",
    "line": "etc",
    "gen": "",
    "genOrder": -1,
    "variant": "",
    "nameKey": "stylefolder"
  },
  {
    "file": "STYLE_FOLDER2.png",
    "path": "/assets/samsung/galaxyA/STYLE_FOLDER2.png",
    "brand": "samsung",
    "line": "etc",
    "gen": "",
    "genOrder": -1,
    "variant": "",
    "nameKey": "stylefolder2"
  },
  {
    "file": "T_KIDSPHONE.png",
    "path": "/assets/samsung/galaxyA/T_KIDSPHONE.png",
    "brand": "samsung",
    "line": "etc",
    "gen": "",
    "genOrder": -1,
    "variant": "",
    "nameKey": "tkidsphone"
  },
  {
    "file": "WIDE.png",
    "path": "/assets/samsung/galaxyA/WIDE.png",
    "brand": "samsung",
    "line": "etc",
    "gen": "",
    "genOrder": -1,
    "variant": "",
    "nameKey": "wide"
  },
  {
    "file": "WIDE2.png",
    "path": "/assets/samsung/galaxyA/WIDE2.png",
    "brand": "samsung",
    "line": "etc",
    "gen": "",
    "genOrder": -1,
    "variant": "",
    "nameKey": "wide2"
  },
  {
    "file": "WIDE3.png",
    "path": "/assets/samsung/galaxyA/WIDE3.png",
    "brand": "samsung",
    "line": "etc",
    "gen": "",
    "genOrder": -1,
    "variant": "",
    "nameKey": "wide3"
  },
  {
    "file": "WIDE4.png",
    "path": "/assets/samsung/galaxyA/WIDE4.png",
    "brand": "samsung",
    "line": "etc",
    "gen": "",
    "genOrder": -1,
    "variant": "",
    "nameKey": "wide4"
  },
  {
    "file": "WIDE5.png",
    "path": "/assets/samsung/galaxyA/WIDE5.png",
    "brand": "samsung",
    "line": "etc",
    "gen": "",
    "genOrder": -1,
    "variant": "",
    "nameKey": "wide5"
  },
  {
    "file": "WIDE6.png",
    "path": "/assets/samsung/galaxyA/WIDE6.png",
    "brand": "samsung",
    "line": "etc",
    "gen": "",
    "genOrder": -1,
    "variant": "",
    "nameKey": "wide6"
  },
  {
    "file": "WIDE7.png",
    "path": "/assets/samsung/galaxyA/WIDE7.png",
    "brand": "samsung",
    "line": "etc",
    "gen": "",
    "genOrder": -1,
    "variant": "",
    "nameKey": "wide7"
  },
  {
    "file": "WIDE8.png",
    "path": "/assets/samsung/galaxyA/WIDE8.png",
    "brand": "samsung",
    "line": "etc",
    "gen": "",
    "genOrder": -1,
    "variant": "",
    "nameKey": "wide8"
  },
  {
    "file": "X-COVER.png",
    "path": "/assets/samsung/galaxyA/X-COVER.png",
    "brand": "samsung",
    "line": "etc",
    "gen": "",
    "genOrder": -1,
    "variant": "",
    "nameKey": "xcover"
  },
  {
    "file": "ZFLIP3.png",
    "path": "/assets/samsung/galaxyFlip/ZFLIP3.png",
    "brand": "samsung",
    "line": "flip",
    "gen": "3",
    "genOrder": 3,
    "variant": ""
  },
  {
    "file": "ZFLIP4.png",
    "path": "/assets/samsung/galaxyFlip/ZFLIP4.png",
    "brand": "samsung",
    "line": "flip",
    "gen": "4",
    "genOrder": 4,
    "variant": ""
  },
  {
    "file": "ZFLIP5.png",
    "path": "/assets/samsung/galaxyFlip/ZFLIP5.png",
    "brand": "samsung",
    "line": "flip",
    "gen": "5",
    "genOrder": 5,
    "variant": ""
  },
  {
    "file": "ZFLIP6.png",
    "path": "/assets/samsung/galaxyFlip/ZFLIP6.png",
    "brand": "samsung",
    "line": "flip",
    "gen": "6",
    "genOrder": 6,
    "variant": ""
  },
  {
    "file": "ZFOLD3.png",
    "path": "/assets/samsung/galaxyFold/ZFOLD3.png",
    "brand": "samsung",
    "line": "fold",
    "gen": "3",
    "genOrder": 3,
    "variant": ""
  },
  {
    "file": "ZFOLD4.png",
    "path": "/assets/samsung/galaxyFold/ZFOLD4.png",
    "brand": "samsung",
    "line": "fold",
    "gen": "4",
    "genOrder": 4,
    "variant": ""
  },
  {
    "file": "ZFOLD5.png",
    "path": "/assets/samsung/galaxyFold/ZFOLD5.png",
    "brand": "samsung",
    "line": "fold",
    "gen": "5",
    "genOrder": 5,
    "variant": ""
  },
  {
    "file": "ZFOLD6.png",
    "path": "/assets/samsung/galaxyFold/ZFOLD6.png",
    "brand": "samsung",
    "line": "fold",
    "gen": "6",
    "genOrder": 6,
    "variant": ""
  },
  {
    "file": "J2_PRO.png",
    "path": "/assets/samsung/galaxyA/J2_PRO.png",
    "brand": "samsung",
    "line": "j",
    "gen": "2",
    "genOrder": 2,
    "variant": "pro"
  },
  {
    "file": "J3.png",
    "path": "/assets/samsung/galaxyA/J3.png",
    "brand": "samsung",
    "line": "j",
    "gen": "3",
    "genOrder": 3,
    "variant": ""
  },
  {
    "file": "J4+.png",
    "path": "/assets/samsung/galaxyA/J4+.png",
    "brand": "samsung",
    "line": "j",
    "gen": "4",
    "genOrder": 4,
    "variant": "plus"
  },
  {
    "file": "J5.png",
    "path": "/assets/samsung/galaxyA/J5.png",
    "brand": "samsung",
    "line": "j",
    "gen": "5",
    "genOrder": 5,
    "variant": ""
  },
  {
    "file": "J6.png",
    "path": "/assets/samsung/galaxyA/J6.png",
    "brand": "samsung",
    "line": "j",
    "gen": "6",
    "genOrder": 6,
    "variant": ""
  },
  {
    "file": "J7.png",
    "path": "/assets/samsung/galaxyA/J7.png",
    "brand": "samsung",
    "line": "j",
    "gen": "7",
    "genOrder": 7,
    "variant": ""
  },
  {
    "file": "M12.png",
    "path": "/assets/samsung/galaxyA/M12.png",
    "brand": "samsung",
    "line": "m",
    "gen": "12",
    "genOrder": 12,
    "variant": ""
  },
  {
    "file": "M20.png",
    "path": "/assets/samsung/galaxyA/M20.png",
    "brand": "samsung",
    "line": "m",
    "gen": "20",
    "genOrder": 20,
    "variant": ""
  },
  {
    "file": "N4.png",
    "path": "/assets/samsung/galaxyNote/N4.png",
    "brand": "samsung",
    "line": "note",
    "gen": "4",
    "genOrder": 4,
    "variant": ""
  },
  {
    "file": "N4 EDGE.png",
    "path": "/assets/samsung/galaxyNote/N4%20EDGE.png",
    "brand": "samsung",
    "line": "note",
    "gen": "4",
    "genOrder": 4,
    "variant": "edge"
  },
  {
    "file": "N5.png",
    "path": "/assets/samsung/galaxyNote/N5.png",
    "brand": "samsung",
    "line": "note",
    "gen": "5",
    "genOrder": 5,
    "variant": ""
  },
  {
    "file": "N7.png",
    "path": "/assets/samsung/galaxyNote/N7.png",
    "brand": "samsung",
    "line": "note",
    "gen": "7",
    "genOrder": 7,
    "variant": ""
  },
  {
    "file": "N7FE.png",
    "path": "/assets/samsung/galaxyNote/N7FE.png",
    "brand": "samsung",
    "line": "note",
    "gen": "7",
    "genOrder": 7,
    "variant": "fe"
  },
  {
    "file": "N8.png",
    "path": "/assets/samsung/galaxyNote/N8.png",
    "brand": "samsung",
    "line": "note",
    "gen": "8",
    "genOrder": 8,
    "variant": ""
  },
  {
    "file": "N9.png",
    "path": "/assets/samsung/galaxyNote/N9.png",
    "brand": "samsung",
    "line": "note",
    "gen": "9",
    "genOrder": 9,
    "variant": ""
  },
  {
    "file": "N10.jpg",
    "path": "/assets/samsung/galaxyNote/N10.jpg",
    "brand": "samsung",
    "line": "note",
    "gen": "10",
    "genOrder": 10,
    "variant": ""
  },
  {
    "file": "N10+.jpg",
    "path": "/assets/samsung/galaxyNote/N10+.jpg",
    "brand": "samsung",
    "line": "note",
    "gen": "10",
    "genOrder": 10,
    "variant": "plus"
  },
  {
    "file": "N20.jpg",
    "path": "/assets/samsung/galaxyNote/N20.jpg",
    "brand": "samsung",
    "line": "note",
    "gen": "20",
    "genOrder": 20,
    "variant": ""
  },
  {
    "file": "N20U.png",
    "path": "/assets/samsung/galaxyNote/N20U.png",
    "brand": "samsung",
    "line": "note",
    "gen": "20",
    "genOrder": 20,
    "variant": "ultra"
  },
  {
    "file": "GALAXY S5.png",
    "path": "/assets/samsung/galaxyS/GALAXY%20S5.png",
    "brand": "samsung",
    "line": "s",
    "gen": "5",
    "genOrder": 5,
    "variant": ""
  },
  {
    "file": "GALAXY S6.png",
    "path": "/assets/samsung/galaxyS/GALAXY%20S6.png",
    "brand": "samsung",
    "line": "s",
    "gen": "6",
    "genOrder": 6,
    "variant": ""
  },
  {
    "file": "GALAXY S6 EDGE.png",
    "path": "/assets/samsung/galaxyS/GALAXY%20S6%20EDGE.png",
    "brand": "samsung",
    "line": "s",
    "gen": "6",
    "genOrder": 6,
    "variant": "edge"
  },
  {
    "file": "GALAXY S7.png",
    "path": "/assets/samsung/galaxyS/GALAXY%20S7.png",
    "brand": "samsung",
    "line": "s",
    "gen": "7",
    "genOrder": 7,
    "variant": ""
  },
  {
    "file": "GALAXY S7 EDGE.png",
    "path": "/assets/samsung/galaxyS/GALAXY%20S7%20EDGE.png",
    "brand": "samsung",
    "line": "s",
    "gen": "7",
    "genOrder": 7,
    "variant": "edge"
  },
  {
    "file": "GALAXY S8.png",
    "path": "/assets/samsung/galaxyS/GALAXY%20S8.png",
    "brand": "samsung",
    "line": "s",
    "gen": "8",
    "genOrder": 8,
    "variant": ""
  },
  {
    "file": "GALAXY S8+.png",
    "path": "/assets/samsung/galaxyS/GALAXY%20S8+.png",
    "brand": "samsung",
    "line": "s",
    "gen": "8",
    "genOrder": 8,
    "variant": "plus"
  },
  {
    "file": "GALAXY S9.png",
    "path": "/assets/samsung/galaxyS/GALAXY%20S9.png",
    "brand": "samsung",
    "line": "s",
    "gen": "9",
    "genOrder": 9,
    "variant": ""
  },
  {
    "file": "GALAXY S9+.jpg",
    "path": "/assets/samsung/galaxyS/GALAXY%20S9+.jpg",
    "brand": "samsung",
    "line": "s",
    "gen": "9",
    "genOrder": 9,
    "variant": "plus"
  },
  {
    "file": "GALAXY S10.png",
    "path": "/assets/samsung/galaxyS/GALAXY%20S10.png",
    "brand": "samsung",
    "line": "s",
    "gen": "10",
    "genOrder": 10,
    "variant": ""
  },
  {
    "file": "GALAXY S10 5G.png",
    "path": "/assets/samsung/galaxyS/GALAXY%20S10%205G.png",
    "brand": "samsung",
    "line": "s",
    "gen": "10",
    "genOrder": 10,
    "variant": "5g"
  },
  {
    "file": "GALAXY S10e.jpg",
    "path": "/assets/samsung/galaxyS/GALAXY%20S10e.jpg",
    "brand": "samsung",
    "line": "s",
    "gen": "10",
    "genOrder": 10,
    "variant": "e"
  },
  {
    "file": "GALAXY S10+.jpg",
    "path": "/assets/samsung/galaxyS/GALAXY%20S10+.jpg",
    "brand": "samsung",
    "line": "s",
    "gen": "10",
    "genOrder": 10,
    "variant": "plus"
  },
  {
    "file": "GALAXY S20.png",
    "path": "/assets/samsung/galaxyS/GALAXY%20S20.png",
    "brand": "samsung",
    "line": "s",
    "gen": "20",
    "genOrder": 20,
    "variant": ""
  },
  {
    "file": "GALAXY S20FE.png",
    "path": "/assets/samsung/galaxyS/GALAXY%20S20FE.png",
    "brand": "samsung",
    "line": "s",
    "gen": "20",
    "genOrder": 20,
    "variant": "fe"
  },
  {
    "file": "GALAXY S20+.png",
    "path": "/assets/samsung/galaxyS/GALAXY%20S20+.png",
    "brand": "samsung",
    "line": "s",
    "gen": "20",
    "genOrder": 20,
    "variant": "plus"
  },
  {
    "file": "GALAXY S20U.png",
    "path": "/assets/samsung/galaxyS/GALAXY%20S20U.png",
    "brand": "samsung",
    "line": "s",
    "gen": "20",
    "genOrder": 20,
    "variant": "ultra"
  },
  {
    "file": "GALAXY S21.png",
    "path": "/assets/samsung/galaxyS/GALAXY%20S21.png",
    "brand": "samsung",
    "line": "s",
    "gen": "21",
    "genOrder": 21,
    "variant": ""
  },
  {
    "file": "GALAXY S21+.png",
    "path": "/assets/samsung/galaxyS/GALAXY%20S21+.png",
    "brand": "samsung",
    "line": "s",
    "gen": "21",
    "genOrder": 21,
    "variant": "plus"
  },
  {
    "file": "GALAXY S21U.png",
    "path": "/assets/samsung/galaxyS/GALAXY%20S21U.png",
    "brand": "samsung",
    "line": "s",
    "gen": "21",
    "genOrder": 21,
    "variant": "ultra"
  },
  {
    "file": "GALAXY S22.png",
    "path": "/assets/samsung/galaxyS/GALAXY%20S22.png",
    "brand": "samsung",
    "line": "s",
    "gen": "22",
    "genOrder": 22,
    "variant": ""
  },
  {
    "file": "GALAXY S22+.png",
    "path": "/assets/samsung/galaxyS/GALAXY%20S22+.png",
    "brand": "samsung",
    "line": "s",
    "gen": "22",
    "genOrder": 22,
    "variant": "plus"
  },
  {
    "file": "GALAXY S22U.png",
    "path": "/assets/samsung/galaxyS/GALAXY%20S22U.png",
    "brand": "samsung",
    "line": "s",
    "gen": "22",
    "genOrder": 22,
    "variant": "ultra"
  },
  {
    "file": "GALAXY S23.png",
    "path": "/assets/samsung/galaxyS/GALAXY%20S23.png",
    "brand": "samsung",
    "line": "s",
    "gen": "23",
    "genOrder": 23,
    "variant": ""
  },
  {
    "file": "GALAXY S23FE.png",
    "path": "/assets/samsung/galaxyS/GALAXY%20S23FE.png",
    "brand": "samsung",
    "line": "s",
    "gen": "23",
    "genOrder": 23,
    "variant": "fe"
  },
  {
    "file": "GALAXY S23+.png",
    "path": "/assets/samsung/galaxyS/GALAXY%20S23+.png",
    "brand": "samsung",
    "line": "s",
    "gen": "23",
    "genOrder": 23,
    "variant": "plus"
  },
  {
    "file": "GALAXY S23U.png",
    "path": "/assets/samsung/galaxyS/GALAXY%20S23U.png",
    "brand": "samsung",
    "line": "s",
    "gen": "23",
    "genOrder": 23,
    "variant": "ultra"
  },
  {
    "file": "GALAXY S24.png",
    "path": "/assets/samsung/galaxyS/GALAXY%20S24.png",
    "brand": "samsung",
    "line": "s",
    "gen": "24",
    "genOrder": 24,
    "variant": ""
  },
  {
    "file": "GALAXY S24FE.png",
    "path": "/assets/samsung/galaxyS/GALAXY%20S24FE.png",
    "brand": "samsung",
    "line": "s",
    "gen": "24",
    "genOrder": 24,
    "variant": "fe"
  },
  {
    "file": "GALAXY S24+.png",
    "path": "/assets/samsung/galaxyS/GALAXY%20S24+.png",
    "brand": "samsung",
    "line": "s",
    "gen": "24",
    "genOrder": 24,
    "variant": "plus"
  },
  {
    "file": "GALAXY S24U.png",
    "path": "/assets/samsung/galaxyS/GALAXY%20S24U.png",
    "brand": "samsung",
    "line": "s",
    "gen": "24",
    "genOrder": 24,
    "variant": "ultra"
  },
  {
    "file": "GALAXY S25.png",
    "path": "/assets/samsung/galaxyS/GALAXY%20S25.png",
    "brand": "samsung",
    "line": "s",
    "gen": "25",
    "genOrder": 25,
    "variant": ""
  },
  {
    "file": "GALAXY S25 엣지.png",
    "path": "/assets/samsung/galaxyS/GALAXY%20S25%20%EC%97%A3%EC%A7%80.png",
    "brand": "samsung",
    "line": "s",
    "gen": "25",
    "genOrder": 25,
    "variant": "edge"
  },
  {
    "file": "GALAXY S25+.png",
    "path": "/assets/samsung/galaxyS/GALAXY%20S25+.png",
    "brand": "samsung",
    "line": "s",
    "gen": "25",
    "genOrder": 25,
    "variant": "plus"
  },
  {
    "file": "GALAXY S25U.png",
    "path": "/assets/samsung/galaxyS/GALAXY%20S25U.png",
    "brand": "samsung",
    "line": "s",
    "gen": "25",
    "genOrder": 25,
    "variant": "ultra"
  },
  {
    "file": "A 10.1_T510,T515.jpg",
    "path": "/assets/samsung/galaxyTab/A_Series/A%2010.1_T510,T515.jpg",
    "brand": "samsung",
    "line": "taba",
    "gen": "",
    "genOrder": -1,
    "variant": "",
    "size": "101"
  },
  {
    "file": "A 10.5_T590,T595.jpg",
    "path": "/assets/samsung/galaxyTab/A_Series/A%2010.5_T590,T595.jpg",
    "brand": "samsung",
    "line": "taba",
    "gen": "",
    "genOrder": -1,
    "variant": "",
    "size": "105"
  },
  {
    "file": "A 8.0_T290,T295.jpg",
    "path": "/assets/samsung/galaxyTab/A_Series/A%208.0_T290,T295.jpg",
    "brand": "samsung",
    "line": "taba",
    "gen": "",
    "genOrder": -1,
    "variant": "",
    "size": "80"
  },
  {
    "file": "A 8.0_P200.jpg",
    "path": "/assets/samsung/galaxyTab/A_Series/A%208.0_P200.jpg",
    "brand": "samsung",
    "line": "taba",
    "gen": "",
    "genOrder": -1,
    "variant": "spen",
    "size": "80"
  },
  {
    "file": "A7 10.4_T500,T505.jpg",
    "path": "/assets/samsung/galaxyTab/A_Series/A7%2010.4_T500,T505.jpg",
    "brand": "samsung",
    "line": "taba",
    "gen": "7",
    "genOrder": 7,
    "variant": "",
    "size": "104"
  },
  {
    "file": "A7 LITE_T220,T225.jpg",
    "path": "/assets/samsung/galaxyTab/A_Series/A7%20LITE_T220,T225.jpg",
    "brand": "samsung",
    "line": "taba",
    "gen": "7",
    "genOrder": 7,
    "variant": "lite"
  },
  {
    "file": "A8 10.5_X200,X205.jpg",
    "path": "/assets/samsung/galaxyTab/A_Series/A8%2010.5_X200,X205.jpg",
    "brand": "samsung",
    "line": "taba",
    "gen": "8",
    "genOrder": 8,
    "variant": "",
    "size": "105"
  },
  {
    "file": "A9_X110.jpg",
    "path": "/assets/samsung/galaxyTab/A_Series/A9_X110.jpg",
    "brand": "samsung",
    "line": "taba",
    "gen": "9",
    "genOrder": 9,
    "variant": ""
  },
  {
    "file": "A9+_X210N.jpg",
    "path": "/assets/samsung/galaxyTab/A_Series/A9+_X210N.jpg",
    "brand": "samsung",
    "line": "taba",
    "gen": "9",
    "genOrder": 9,
    "variant": "plus"
  },
  {
    "file": "S6_T860,T865.jpg",
    "path": "/assets/samsung/galaxyTab/S_Series/S6_T860,T865.jpg",
    "brand": "samsung",
    "line": "tabs",
    "gen": "6",
    "genOrder": 6,
    "variant": ""
  },
  {
    "file": "S6 LITE_P610,P615.jpg",
    "path": "/assets/samsung/galaxyTab/S_Series/S6%20LITE_P610,P615.jpg",
    "brand": "samsung",
    "line": "tabs",
    "gen": "6",
    "genOrder": 6,
    "variant": "lite"
  },
  {
    "file": "S7_T870,T875.jpg",
    "path": "/assets/samsung/galaxyTab/S_Series/S7_T870,T875.jpg",
    "brand": "samsung",
    "line": "tabs",
    "gen": "7",
    "genOrder": 7,
    "variant": ""
  },
  {
    "file": "S7FE_T733,T735,T736.jpg",
    "path": "/assets/samsung/galaxyTab/S_Series/S7FE_T733,T735,T736.jpg",
    "brand": "samsung",
    "line": "tabs",
    "gen": "7",
    "genOrder": 7,
    "variant": "fe"
  },
  {
    "file": "S7+_T970,T975,T976.jpg",
    "path": "/assets/samsung/galaxyTab/S_Series/S7+_T970,T975,T976.jpg",
    "brand": "samsung",
    "line": "tabs",
    "gen": "7",
    "genOrder": 7,
    "variant": "plus"
  },
  {
    "file": "S8_X700,X706.jpg",
    "path": "/assets/samsung/galaxyTab/S_Series/S8_X700,X706.jpg",
    "brand": "samsung",
    "line": "tabs",
    "gen": "8",
    "genOrder": 8,
    "variant": ""
  },
  {
    "file": "S8+_X800,X806.jpg",
    "path": "/assets/samsung/galaxyTab/S_Series/S8+_X800,X806.jpg",
    "brand": "samsung",
    "line": "tabs",
    "gen": "8",
    "genOrder": 8,
    "variant": "plus"
  },
  {
    "file": "S8U_X900,X906.jpg",
    "path": "/assets/samsung/galaxyTab/S_Series/S8U_X900,X906.jpg",
    "brand": "samsung",
    "line": "tabs",
    "gen": "8",
    "genOrder": 8,
    "variant": "ultra"
  },
  {
    "file": "S9_X710,X716.jpg",
    "path": "/assets/samsung/galaxyTab/S_Series/S9_X710,X716.jpg",
    "brand": "samsung",
    "line": "tabs",
    "gen": "9",
    "genOrder": 9,
    "variant": ""
  },
  {
    "file": "S9FE.jpg",
    "path": "/assets/samsung/galaxyTab/S_Series/S9FE.jpg",
    "brand": "samsung",
    "line": "tabs",
    "gen": "9",
    "genOrder": 9,
    "variant": "fe"
  },
  {
    "file": "S9FE+.jpg",
    "path": "/assets/samsung/galaxyTab/S_Series/S9FE+.jpg",
    "brand": "samsung",
    "line": "tabs",
    "gen": "9",
    "genOrder": 9,
    "variant": "feplus"
  },
  {
    "file": "S9+_X810,X816.jpg",
    "path": "/assets/samsung/galaxyTab/S_Series/S9+_X810,X816.jpg",
    "brand": "samsung",
    "line": "tabs",
    "gen": "9",
    "genOrder": 9,
    "variant": "plus"
  },
  {
    "file": "S9U_X910,X916.jpg",
    "path": "/assets/samsung/galaxyTab/S_Series/S9U_X910,X916.jpg",
    "brand": "samsung",
    "line": "tabs",
    "gen": "9",
    "genOrder": 9,
    "variant": "ultra"
  },
  {
    "file": "S10FE_X520,X526.jpg",
    "path": "/assets/samsung/galaxyTab/S_Series/S10FE_X520,X526.jpg",
    "brand": "samsung",
    "line": "tabs",
    "gen": "10",
    "genOrder": 10,
    "variant": "fe"
  },
  {
    "file": "S10FE+_X620,X626.jpg",
    "path": "/assets/samsung/galaxyTab/S_Series/S10FE+_X620,X626.jpg",
    "brand": "samsung",
    "line": "tabs",
    "gen": "10",
    "genOrder": 10,
    "variant": "feplus"
  },
  {
    "file": "S10+_X810,X825.jpg",
    "path": "/assets/samsung/galaxyTab/S_Series/S10+_X810,X825.jpg",
    "brand": "samsung",
    "line": "tabs",
    "gen": "10",
    "genOrder": 10,
    "variant": "plus"
  },
  {
    "file": "S10U_X920.jpg",
    "path": "/assets/samsung/galaxyTab/S_Series/S10U_X920.jpg",
    "brand": "samsung",
    "line": "tabs",
    "gen": "10",
    "genOrder": 10,
    "variant": "ultra"
  }
];
